import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { XenaDSAccessor } from './xenads-accessor';

@Directive({
    selector: 'xena-input:not([number]), xena-radio-group, xena-textarea, [xenaDSControl]',
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: XenaDSInputValueAccessorDirective, multi: true }],
    standalone: false
})
export class XenaDSInputValueAccessorDirective extends XenaDSAccessor implements ControlValueAccessor {
  constructor(element: ElementRef, renderer: Renderer2) {
    super(element, renderer, 'value');
  }

  @HostListener('valueChange', ['$event'])
  _handleValueChange(event: CustomEvent) {
    super._handleValueChange(event);
  }

  @HostListener('xnBlur')
  handleTouched() {
    if (this.onTouched) { this.onTouched(); }
  }

  @Input('readonly')
  set isReadonly(isReadonly: boolean) {
    this.renderer.setProperty(this.element.nativeElement, 'readonly', isReadonly);
  }
}
